import { apiRequest } from './apiClient'
import { getValidToken, hasRefreshableSession } from './authService'
import { withDeduplication } from '../utils/requestDeduplication'

// ?????????? Authorization-?????????, ?????? ??? ?????? ?????, ????? ?????? ??? ???????????.
function withAuth(options = {}) {
  const token = getValidToken()
  if (!token) {
    // Токен в памяти протух (вкладка висела в фоне дольше TTL access-токена).
    // Это не разлогин: refresh-cookie жива, apiClient сам сделает silentRefresh
    // и подставит свежий токен. Падаем только когда сессии нет вообще.
    if (hasRefreshableSession()) return options
    throw new Error('token_required')
  }

  return {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  }
}

// Дедуплицированные функции для предотвращения дублирующих параллельных запросов
const _fetchSession = () => apiRequest('/session', withAuth())
export const fetchSession = withDeduplication(_fetchSession)

// Фіксуємо відвідування (відкриття вкладки з живим токеном без повторного логіну)
export function reportVisit() {
  return apiRequest('/visit', withAuth({ method: 'POST' })).catch(() => {})
}

const _fetchDevices = () => apiRequest('/devices', withAuth())
export const fetchDevices = withDeduplication(_fetchDevices)

const _fetchDevicesLatestTelemetry = async () => {
  // ??+ñ>ññ úø?ø?ø ?ø?ñ óø?ñ?ç õ?ñóç? ??ç?ñó ñú ?øõ?>‘?ú??ø‘'‘?? ?ø >?ñ??ü ?ø?ó?ç ?ç?ñü.
  try {
    return await apiRequest('/devices/telemetry/latest', withAuth())
  } catch (err) {
    // ö+?ø?ñ?ñ‘?‘? >ñ+???>ç? óøó ?ó?øú? ?ç?ñó, ?ç?øóñ‘?ç ???ø>‘??? +‘<>? ñ øóñ?ñ‘?, +çú õ? >??ñ ?+?óø>ñ ???ñ? ?ø óø?ñ.
    if (String(err?.message || '').includes('404')) {
      return fetchDevices()
    }
    throw err
  }
}
export const fetchDevicesLatestTelemetry = withDeduplication(_fetchDevicesLatestTelemetry)

export function fetchDeviceTelemetry(deviceId) {
  // ????? ????????? ?????????? ?? ??????????? ??????????.
  return apiRequest(`/devices/${deviceId}/telemetry`, withAuth())
}

export async function fetchDeviceRoute(deviceId, { from, to } = {}) {
  // Запрашиваем маршрут устройства за выбранный период, максимально 3 месяца.
  const query = new URLSearchParams()
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  const resp = await apiRequest(`/devices/${deviceId}/route?${query.toString()}`, withAuth())
  // Бэкенд віддає компактний формат: на точці {sensorId: value}, schema окремо.
  // Розгортаємо назад у sensorsMetric — споживачі (графіки/карта/експорт) працюють як раніше.
  expandRouteSensors(resp?.route)
  return resp
}

// Реконструкція sensorsMetric з компактного формату {sensors:{id:value}} + sensorsSchema.
// Економія трафіку ~5x (252MB→50MB raw на 144К точках).
// ЛІНИВО: раніше масиви метрик будувались одразу для всіх точок — на тижневих маршрутах
// це ~200мс+GC синхронно після fetch, хоча карті (renderRouteOnMap) sensorsMetric не потрібен.
// Тепер вішаємо self-caching getter: метрики точки розгортаються при першому зверненні
// (попап активної точки, відкриті графіки, експорт) і кешуються як звичайна властивість.
function expandRouteSensors(route) {
  if (!route || !Array.isArray(route.points)) return
  const schema = route.sensorsSchema || {}
  // Один спільний getter/setter на весь маршрут (schema в замиканні), а не замикання на кожну точку
  const lazyGet = function () {
    const metrics = buildSensorsMetric(this.sensors, schema)
    // Кешуємо: заміняємо getter звичайною властивістю і звільняємо компактні дані
    Object.defineProperty(this, 'sensorsMetric', {
      value: metrics, writable: true, configurable: true, enumerable: true,
    })
    delete this.sensors
    return metrics
  }
  const lazySet = function (v) {
    Object.defineProperty(this, 'sensorsMetric', {
      value: v, writable: true, configurable: true, enumerable: true,
    })
  }
  const descriptor = { configurable: true, enumerable: true, get: lazyGet, set: lazySet }
  for (const point of route.points) {
    // hasOwnProperty замість point.sensorsMetric — щоб повторний виклик не тригерив getter'и
    if (!point || !point.sensors || Object.prototype.hasOwnProperty.call(point, 'sensorsMetric')) continue
    Object.defineProperty(point, 'sensorsMetric', descriptor)
  }
}

// Побудова масиву метрик однієї точки з компактного формату (викликається ліниво з getter'а)
function buildSensorsMetric(sensors, schema) {
  const metrics = []
  if (!sensors) return metrics
  for (const sidKey of Object.keys(sensors)) {
    const value = sensors[sidKey]
    const s = schema[sidKey] || {}
    const sensorIdNum = Number(sidKey)
    const sensorId = Number.isFinite(sensorIdNum) && String(sensorIdNum) === sidKey ? sensorIdNum : sidKey
    const displayFmt = s.displayFmt || ''
    let displayValue = value
    if (displayFmt && value !== null && value !== undefined && Number.isFinite(Number(value))) {
      displayValue = formatBySprintf(displayFmt, Number(value))
    }
    metrics.push({
      sensorId,
      name: s.name || '',
      value,
      displayValue,
      displayFmt,
      unit: s.unit || '',
      profileId: s.profileId ?? null,
      profileKind: s.profileKind ?? null,
      // Роль текстового датчика: VIN і ICCID у таблиці маршруту не показуємо
      textRole: s.textRole ?? null,
      flowmeterMode: s.flowmeterMode ?? null,
      counterMode: s.counterMode ?? null,
      // Режим «Заправки»: графіки накопичують її як витратомір
      dispenserMode: s.dispenserMode ?? null,
      tankCapacity: s.tankCapacity ?? null,
    })
  }
  return metrics
}

// Мінімальна реалізація PHP-style sprintf для %.Nf / %d / %s — ті формати, що використовує бекенд.
function formatBySprintf(fmt, value) {
  const m = String(fmt).match(/%(?:\.(\d+))?([dfs])/)
  if (!m) return String(value)
  const decimals = m[1] != null ? Number(m[1]) : 0
  const type = m[2]
  if (type === 'd') return String(Math.trunc(Number(value)))
  if (type === 'f') return Number(value).toFixed(decimals)
  return String(value)
}

/**
 * Інкрементальне отримання телеметрії для live-режиму маршруту.
 * Повертає тільки нові точки після вказаного timestamp.
 * @param {number} deviceId - ID пристрою
 * @param {string} since - Timestamp останньої відомої точки (ISO формат)
 * @param {number} limit - Максимальна кількість точок (за замовчуванням 100)
 * @returns {Promise<{points: Array, hasMore: boolean}>}
 */
export function fetchDeviceIncrementalTelemetry(deviceId, { since, limit = 100 } = {}) {
  const query = new URLSearchParams()
  if (since) query.set('since', since)
  if (limit) query.set('limit', String(limit))
  return apiRequest(`/devices/${deviceId}/telemetry/incremental?${query.toString()}`, withAuth())
}

export function fetchDeviceFuelAnalysis(deviceId, { from, to, sensorId, trace } = {}) {
  // Get fuel sensor analysis with refuel and drain event detection
  // trace: 1 — трасса решений валидатора (только impersonate-сессии, окно «Діагностика»)
  const query = new URLSearchParams()
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  if (sensorId) query.set('sensorId', sensorId)
  if (trace) query.set('trace', '1')
  return apiRequest(`/devices/${deviceId}/fuel-analysis?${query.toString()}`, withAuth())
}

// Порушення якості водіння для треку. Окремим запитом, а не в /route: маршрут
// вантажиться на кожне відкриття карти, а тут потрібен повний прохід по телеметрії.
// Вантажимо паралельно з маршрутом, як fuel-analysis.
export function fetchDeviceEcoViolations(deviceId, { from, to } = {}) {
  const query = new URLSearchParams()
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  return apiRequest(`/devices/${deviceId}/eco-violations?${query.toString()}`, withAuth())
}

// ====== Fuel Event Corrections (тільки для impersonate-сесій) ======
export function fetchFuelCorrections(deviceId) {
  return apiRequest(`/devices/${deviceId}/fuel-corrections`, withAuth())
}

export function createFuelCorrection(deviceId, data) {
  return apiRequest(`/devices/${deviceId}/fuel-corrections`, {
    ...withAuth(),
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function deleteFuelCorrection(deviceId, correctionId) {
  return apiRequest(`/devices/${deviceId}/fuel-corrections/${correctionId}`, {
    ...withAuth(),
    method: 'DELETE',
  })
}

export function fetchSensorRawData(deviceId, sensorId, { from, to } = {}) {
  // Получаем RAW данные сенсора из telemetry.sensors_json за период
  // Используется редко - загружается только по запросу пользователя
  const query = new URLSearchParams()
  query.set('sensorId', sensorId)
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  return apiRequest(`/devices/${deviceId}/sensor-raw?${query.toString()}`, withAuth())
}

export function fetchSensorHistory(deviceId, sensorId, { from, to, maxPoints } = {}) {
  // Калібровані дані сенсора з sensors_metric_json для sparkline віджетів
  const query = new URLSearchParams()
  query.set('deviceId', String(deviceId))
  query.set('sensorId', String(sensorId))
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  if (maxPoints) query.set('maxPoints', String(maxPoints))
  return apiRequest(`/widgets/sensor-history?${query.toString()}`, withAuth())
}

export function fetchDigitalInputHistory(deviceId, inputNumber, { from, to, maxPoints } = {}) {
  // Історія стану цифрового входу з sensors_json.digital для sparkline віджетів
  const query = new URLSearchParams()
  query.set('deviceId', String(deviceId))
  query.set('inputNumber', String(inputNumber))
  if (from) query.set('from', from)
  if (to) query.set('to', to)
  if (maxPoints) query.set('maxPoints', String(maxPoints))
  return apiRequest(`/widgets/digital-input-history?${query.toString()}`, withAuth())
}

export function updateDeviceMeta(deviceId, payload) {
  // ????????? ?????????? ?????????? (???, ????????, ????????) ? ???????????? ???????.
  return apiRequest(`/devices/${deviceId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
    ...withAuth(),
  })
}

const _fetchWidgetCatalog = () => apiRequest('/widgets/catalog', withAuth())
export const fetchWidgetCatalog = withDeduplication(_fetchWidgetCatalog)

const _fetchWidgetLayout = () => apiRequest('/widgets/layout', withAuth())
export const fetchWidgetLayout = withDeduplication(_fetchWidgetLayout)

export function saveWidgetLayout(layout) {
  // ?????????? ??? JSON-??????? ?????? ??????????, ????? ?? ???? ?????????? ???????????? ???????
  return apiRequest('/widgets/layout', {
    method: 'PUT',
    body: JSON.stringify({ layout }),
    ...withAuth(),
  })
}

// Дедуплицированные widget fetch функции — предотвращают дублирование параллельных запросов
const _fetchDeviceStatsWidget = () => apiRequest('/widgets/device-stats', withAuth())
export const fetchDeviceStatsWidget = withDeduplication(_fetchDeviceStatsWidget)

const _fetchRecentDevicesWidget = () => apiRequest('/widgets/recent-devices', withAuth())
export const fetchRecentDevicesWidget = withDeduplication(_fetchRecentDevicesWidget)

const _fetchMovementWidget = () => {
  const now = new Date()
  const startOfDay = new Date(now)
  startOfDay.setHours(0, 0, 0, 0)
  // Формируем границу от локальной полуночи пользователя, чтобы бэкенд считал активность за текущий день в его часовом поясе
  const query = new URLSearchParams({ from: startOfDay.toISOString() })
  return apiRequest(`/widgets/movement?${query.toString()}`, withAuth())
}
export const fetchMovementWidget = withDeduplication(_fetchMovementWidget)

const _fetchDailyMileageWidget = () => {
  // Запрашиваем серверные данные о пробеге по самым активным устройствам за текущий день.
  // Передаём локальную полночь пользователя, чтобы сервер считал пробег в его часовом поясе.
  const now = new Date()
  const startOfDay = new Date(now)
  startOfDay.setHours(0, 0, 0, 0)
  const query = new URLSearchParams({ from: startOfDay.toISOString() })
  return apiRequest(`/widgets/daily-mileage?${query.toString()}`, withAuth())
}
export const fetchDailyMileageWidget = withDeduplication(_fetchDailyMileageWidget)

// === CONFIGURABLE WIDGET FETCH FUNCTIONS (с дедупликацией) ===

const _fetchUpcomingMaintenanceWidget = (deviceIds, limit = 5) => {
  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  query.set('limit', String(limit))
  return apiRequest(`/widgets/upcoming-maintenance?${query.toString()}`, withAuth())
}
export const fetchUpcomingMaintenanceWidget = withDeduplication(_fetchUpcomingMaintenanceWidget)

const _fetchFuelWidget = (deviceIds) => {
  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  return apiRequest(`/widgets/fuel?${query.toString()}`, withAuth())
}
export const fetchFuelWidget = withDeduplication(_fetchFuelWidget)

const _fetchSpeedViolationsWidget = (deviceIds, speedLimit = 90) => {
  const now = new Date()
  const startOfDay = new Date(now)
  startOfDay.setHours(0, 0, 0, 0)

  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  query.set('speedLimit', String(speedLimit))
  query.set('from', startOfDay.toISOString())
  return apiRequest(`/widgets/speed-violations?${query.toString()}`, withAuth())
}
export const fetchSpeedViolationsWidget = withDeduplication(_fetchSpeedViolationsWidget)

const _fetchTempViolationsWidget = (deviceIds, sensorId) => {
  const now = new Date()
  const startOfDay = new Date(now)
  startOfDay.setHours(0, 0, 0, 0)

  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  if (sensorId != null) query.set('sensorId', String(sensorId))
  query.set('from', startOfDay.toISOString())
  return apiRequest(`/widgets/temp-violations?${query.toString()}`, withAuth())
}
export const fetchTempViolationsWidget = withDeduplication(_fetchTempViolationsWidget)

// Віджет якості водіння. Читає денні агрегати (eco_driving_daily), тому
// відповідає миттєво. Порожня відповідь (fleet = null) означає, що нічний
// розрахунок ще не проходив або модуль ніде не увімкнений — віджет мусить
// сказати про це, а не малювати нулі.
const _fetchEcoDrivingWidget = (deviceIds, days = 7, limit = 5) => {
  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  query.set('days', String(days))
  query.set('limit', String(limit))
  return apiRequest(`/widgets/eco-driving?${query.toString()}`, withAuth())
}
export const fetchEcoDrivingWidget = withDeduplication(_fetchEcoDrivingWidget)

const _fetchEngineHoursWidget = (deviceIds, period = 'today', limit = 10) => {
  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  query.set('period', period)
  query.set('limit', String(limit))
  return apiRequest(`/widgets/engine-hours?${query.toString()}`, withAuth())
}
export const fetchEngineHoursWidget = withDeduplication(_fetchEngineHoursWidget)

const _fetchInactiveDevicesWidget = (inactiveDays = 3) => {
  const query = new URLSearchParams({ inactiveDays: String(inactiveDays) })
  return apiRequest(`/widgets/inactive-devices?${query.toString()}`, withAuth())
}
export const fetchInactiveDevicesWidget = withDeduplication(_fetchInactiveDevicesWidget)

const _fetchScheduledReportsWidget = (limit = 5) => {
  const query = new URLSearchParams({ limit: String(limit) })
  return apiRequest(`/widgets/scheduled-reports?${query.toString()}`, withAuth())
}
export const fetchScheduledReportsWidget = withDeduplication(_fetchScheduledReportsWidget)

const _fetchGeozoneActivityWidget = (geozoneIds, deviceIds) => {
  const query = new URLSearchParams()
  if (geozoneIds?.length) query.set('geozoneIds', geozoneIds.join(','))
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  return apiRequest(`/widgets/geozone-activity?${query.toString()}`, withAuth())
}
export const fetchGeozoneActivityWidget = withDeduplication(_fetchGeozoneActivityWidget)

const _fetchDriverStatsWidget = (period = 'week', limit = 5) => {
  const query = new URLSearchParams({ period, limit: String(limit) })
  return apiRequest(`/widgets/driver-stats?${query.toString()}`, withAuth())
}
export const fetchDriverStatsWidget = withDeduplication(_fetchDriverStatsWidget)

const _fetchTrailerUsageWidget = (period = 'week', limit = 5) => {
  const query = new URLSearchParams({ period, limit: String(limit) })
  return apiRequest(`/widgets/trailer-usage?${query.toString()}`, withAuth())
}
export const fetchTrailerUsageWidget = withDeduplication(_fetchTrailerUsageWidget)

// e-TOLL balance widget - баланси всіх billing accounts користувача
const _fetchEtollBalanceWidget = () => apiRequest('/regtech/etoll-balances', withAuth())
export const fetchEtollBalanceWidget = withDeduplication(_fetchEtollBalanceWidget)

// Подозрительные сливы топлива - читает таблицу event (kind=fuel_drain)
const _fetchFuelDrainsWidget = (deviceIds, days = 7, limit = 10) => {
  const query = new URLSearchParams()
  if (deviceIds?.length) query.set('deviceIds', deviceIds.join(','))
  query.set('days', String(days))
  query.set('limit', String(limit))
  return apiRequest(`/widgets/fuel-drains?${query.toString()}`, withAuth())
}
export const fetchFuelDrainsWidget = withDeduplication(_fetchFuelDrainsWidget)

// Sensors widget - показники обраних датчиків конкретного пристрою
// fuelTank: датчик рівня ємності віджета «Паливо». Сервер додає її датчики з профілю приладу
// й повертає налаштування ємності (fuelTank)
const _fetchSensorsWidget = (deviceId, sensorIds, fuelTank = null) => {
  const query = new URLSearchParams()
  if (deviceId) query.set('deviceId', String(deviceId))
  if (sensorIds?.length) query.set('sensorIds', sensorIds.join(','))
  if (fuelTank !== null && fuelTank !== undefined && fuelTank !== '') query.set('fuelTank', String(fuelTank))
  return apiRequest(`/widgets/sensors?${query.toString()}`, withAuth())
}
export const fetchSensorsWidget = withDeduplication(_fetchSensorsWidget)

// Digital inputs widget - стан цифрових входів конкретного пристрою
const _fetchDigitalInputsWidget = (deviceId, inputNumbers) => {
  const query = new URLSearchParams()
  if (deviceId) query.set('deviceId', String(deviceId))
  if (inputNumbers?.length) query.set('inputNumbers', inputNumbers.join(','))
  return apiRequest(`/widgets/digital-inputs?${query.toString()}`, withAuth())
}
export const fetchDigitalInputsWidget = withDeduplication(_fetchDigitalInputsWidget)

const _fetchUserProfile = () => apiRequest('/user/profile', withAuth())
export const fetchUserProfile = withDeduplication(_fetchUserProfile)

export function updateUserProfile(payload) {
  // Обновляем имя и дополнительные поля профиля без права менять чужие записи.
  return apiRequest('/user/profile', {
    method: 'PATCH',
    body: JSON.stringify(payload),
    ...withAuth(),
  })
}

export function uploadUserAvatar(file) {
  // Отправляем файл аватара через FormData, чтобы PHP получил бинарные данные без перекодирования.
  const formData = new FormData()
  formData.append('avatar', file)

  return apiRequest('/user/avatar', withAuth({ method: 'POST', body: formData, headers: {} }))
}

export function deleteUserAvatar() {
  // Удаляем аватар пользователя с сервера.
  return apiRequest('/user/avatar', withAuth({ method: 'DELETE' }))
}

export function requestEmailChange(email) {
  // Запрашиваем смену email с отправкой письма-подтверждения на новую почту.
  return apiRequest('/user/email/change', {
    method: 'POST',
    body: JSON.stringify({ email }),
    ...withAuth(),
  })
}

export function saveTechnicalEmail(technicalEmail) {
  // Сохраняем технический email для оповещений (без подтверждения).
  return apiRequest('/user/technical-email', {
    method: 'PUT',
    body: JSON.stringify({ technicalEmail }),
    ...withAuth(),
  })
}

// ======================
// TELEGRAM LINKING (поддержка нескольких аккаунтов)
// ======================

export function getTelegramLinkCode() {
  // Генерирует код верификации Telegram и возвращает deep link для привязки.
  return apiRequest('/user/telegram/link', withAuth())
}

export function unlinkTelegramAccount(telegramId) {
  // Отвязывает конкретный Telegram аккаунт по его ID.
  return apiRequest(`/user/telegram/${telegramId}`, {
    method: 'DELETE',
    ...withAuth(),
  })
}

export function getTelegramAccounts() {
  // Получает список всех привязанных Telegram аккаунтов пользователя.
  return apiRequest('/user/telegram/accounts', withAuth())
}

// ======================
// VIBER LINKING (поддержка нескольких аккаунтов)
// ======================

export function getViberLinkCode() {
  // Генерирует код верификации Viber и возвращает deep link для привязки.
  return apiRequest('/user/viber/link', withAuth())
}

export function unlinkViberAccount(viberId) {
  // Отвязывает конкретный Viber аккаунт по его ID.
  return apiRequest(`/user/viber/${viberId}`, {
    method: 'DELETE',
    ...withAuth(),
  })
}

export function getViberAccounts() {
  // Получает список всех привязанных Viber аккаунтов пользователя.
  return apiRequest('/user/viber/accounts', withAuth())
}

// ======================
// NOTIFICATION PREFERENCES
// ======================

export function getNotificationPreferences() {
  // Получает настройки уведомлений пользователя (матрица event_type × channel).
  return apiRequest('/user/notification-preferences', withAuth())
}

export function getNotificationSettings() {
  // Агрегированный эндпоинт: все настройки уведомлений + устройства с триггерами и геозонами
  return apiRequest('/user/notification-settings', withAuth())
}

export function updateNotificationPreferences(preferences) {
  // Обновляет настройки уведомлений пользователя.
  return apiRequest('/user/notification-preferences', {
    method: 'PATCH',
    body: JSON.stringify({ preferences }),
    ...withAuth(),
  })
}

export function changePassword(currentPassword, newPassword) {
  // Меняем пароль пользователя, требуя ввод текущего пароля для подтверждения.
  return apiRequest('/user/password', {
    method: 'POST',
    body: JSON.stringify({ currentPassword, newPassword }),
    ...withAuth(),
  })
}

const _fetchTenantLogo = () => apiRequest('/tenant/logo', withAuth())
export const fetchTenantLogo = withDeduplication(_fetchTenantLogo)

const _fetchTenantContact = () => apiRequest('/tenant/contact', withAuth())
export const fetchTenantContact = withDeduplication(_fetchTenantContact)

const _fetchBillingStatusInfo = () => apiRequest('/billing/status', withAuth())
export const fetchBillingStatusInfo = withDeduplication(_fetchBillingStatusInfo)

// ======================
// DEVICE OUTPUT CONTROL
// ======================

export function getDeviceOutputState(deviceId) {
  // Получаем текущее состояние цифровых выходов устройства.
  return apiRequest(`/devices/${deviceId}/output`, withAuth())
}

export function setDeviceOutputState(deviceId, outputMask) {
  // Устанавливаем состояние цифровых выходов устройства.
  // outputMask - битовая маска (0-255): бит 0 = OUT1, бит 1 = OUT2, ...
  return apiRequest(`/devices/${deviceId}/output`, {
    method: 'POST',
    body: JSON.stringify({ outputMask }),
    ...withAuth(),
  })
}

// ======================
// API TOKENS
// ======================

export function fetchApiTokens() {
  // Получаем список API-токенов текущего пользователя.
  return apiRequest('/user/api-tokens', withAuth())
}

export function createApiToken(payload) {
  // Создаём новый API-токен с именем и набором разрешений (scopes).
  return apiRequest('/user/api-tokens', withAuth({
    method: 'POST',
    body: JSON.stringify(payload),
  }))
}

export function updateApiToken(id, payload) {
  return apiRequest(`/user/api-tokens/${id}`, withAuth({
    method: 'PATCH',
    body: JSON.stringify(payload),
  }))
}

export function revokeApiToken(id) {
  // Отзываем (деактивируем) API-токен по его ID — токен больше не принимається сервером.
  return apiRequest(`/user/api-tokens/${id}`, withAuth({
    method: 'DELETE',
  }))
}

// ==================== UI SETTINGS ====================

export function fetchUiSettings() {
  return apiRequest('/user/ui-settings', withAuth())
}

export function updateUiSettings(patch) {
  return apiRequest('/user/ui-settings', withAuth({
    method: 'PATCH',
    body: JSON.stringify(patch),
  }))
}
